import React from 'react';
import carFooter from '../../../SellerStack/assets/images/carFooter.png'; 

const Footer = () => {
  return (
    <div style={footerStyle}>
      <img 
        src={carFooter}  
        alt="Footer" 
        style={imageStyle}
      />
    </div>
  );
};

const footerStyle = {
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center',
  width: '100%',
  marginTop: '30px',
  paddingBottom: '20px',
};

const imageStyle = {
  width: '747px',
  height: '257px',
  objectFit: 'cover',
};

export default Footer;
